'use strict';
angular.module('meanApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('step2', {
        url: '/step2/:clientId',
        params: {},
        templateUrl: 'app/tpcPortal/step2/step2.html',
        controller: 'step2-controller',
        authenticate: ['user','admin']
      })

  });
